import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AmplifyModelService } from '../services/amplify-model-service.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  private authService = inject(AmplifyModelService);
  private router = inject(Router);

  async canActivate(): Promise<boolean> {
    try {
      console.log('🛡️ AdminGuard - Checking admin access...');
      const groups = await this.authService.getUserGroups();
      console.log('👥 AdminGuard - User groups:', groups);
      
      if (groups.includes('ADMINS')) {
        console.log('✅ AdminGuard - Access granted (user is admin)');
        return true;
      }
      
      console.log('❌ AdminGuard - Access denied (user is not admin)');
      // Redirect to appropriate portal based on their actual groups
      const defaultRoute = this.getDefaultRouteForGroups(groups);
      console.log('🔄 AdminGuard - Redirecting to:', defaultRoute);
      this.router.navigate([defaultRoute]);
      return false;
    } catch (error) {
      console.log('🚫 AdminGuard - Authentication error, redirecting to login');
      console.error('AdminGuard error:', error);
      this.router.navigate(['/login']);
      return false;
    }
  }

  private getDefaultRouteForGroups(groups: string[]): string {
    // Everyone goes to dashboard with appropriate menu
    return '/dashboard';
  }
}